import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const StrategySelectorModalWrapper = styled.div`
  .strategy-selector-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 476px;
    /* The selector inside is a fixed 440px and cannot shrink, so the card has
       to clear it plus its own padding-bottom */
    height: 448px;
    background-color: ${colors.white};
    border-radius: 16px;
    padding-bottom: 8px;
  }
`;
